import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from 'antd';

import { Navbar } from '../layout/Header';
import { ProfileTabs } from './components/ProfileTabs';
import { ContactSupport } from './components/ProfileContents';
import { getUserState } from '../../store/user/selector';
import { getMyMeals } from '../../store/meals/actions';
import { getOrders } from '../../store/orders/actions';
import { syncUser, getUserRating } from '../../store/user/actions';

const COOK = 'cook';
const GUEST = 'guest';

export const Profile: React.FC = () => {
  const dispatch = useDispatch();
  const { user } = useSelector(getUserState);

  useEffect(() => {
    dispatch(syncUser());
    dispatch(getUserRating());
    if (user.accountType === COOK) {
      dispatch(getMyMeals());
    }
    if (user.accountType === GUEST) {
      dispatch(getOrders());
    }
  }, [user, dispatch]);
  return (
    <div className="dashboard">
      <Row>
        <Navbar />
      </Row>
      <Row className="profile-container" justify="center">
        <Col span={24} className="profile-screen">
          <ProfileTabs />
          <ContactSupport />
        </Col>
      </Row>
    </div>
  );
};
